import { Report } from '@common/Execution/Report';
import { ExecutionStep } from '@common/Execution/types';
import { Badges, Centered, SlidingPanel, Spinner, Button } from '@prophecy/ui-v3';
import { useState } from 'react';

import { useJobRunLogs } from '../hooks';
import { ObservationType } from '../query';

export const RunDetail = (props: ObservationType & { fabricId: string }) => {
  const [runId, setDialogRunID] = useState('');
  const currentId = props.databricksRunId || props.airflowDagRunId;
  const enabled = runId === currentId;
  const { isLoading, isError, error, data } = useJobRunLogs({ ...props, enabled });
  const steps: ExecutionStep[] = (data || []) as ExecutionStep[];
  return (
    <>
      <Button
        variant='secondaryGray'
        size='s'
        onClick={() => setDialogRunID(currentId as string)}
        data-test-id='observation-run-details-button'>
        Details
      </Button>
      <SlidingPanel open={enabled} onClose={() => setDialogRunID('')}>
        {isLoading ? (
          <Centered>
            <Spinner spinning />
          </Centered>
        ) : isError && error ? (
          <Centered>
            <Badges tone='error'>{error.message || 'Something went wrong'}</Badges>
          </Centered>
        ) : (
          <Report steps={steps} />
        )}
      </SlidingPanel>
    </>
  );
};
